const logConfig = {
  error: true,
  warn: true,
  info: true,
  log: true,
};

export default logConfig;
